module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_healthcare-9957024a.png";